import React, { useEffect } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { LOGIN, ROOT, USER_PROFILE } from '../constants/routes';
import MainLayout from './layout/MainLayout';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthUser, selectIsAuthorizing } from '../reducers/auth/auth.selectors';
import Loader from './Loader';
import { getToken } from '../helpers';
import { Helmet } from 'react-helmet';
import { appName } from '../constants/const';

const PrivateRoute = ({
  component: Component,
  header = true,
  props,
  allowedRole,
  layout: Layout = MainLayout,
  title,
  ...rest
}) => {
  const user = useSelector(selectAuthUser);
  const token = getToken();
  const location = useLocation();
  if (token && !user) return <Loader isLoadin={true} size={60} />;
  return (
    <Route
      {...rest}
      render={props => {
        return user ? (
          !allowedRole || user.role <= allowedRole ? (
            <Layout header={header}>
              <Helmet>
                <title>{title ? title + ' | ' + appName : appName}</title>
              </Helmet>
              <Component {...props} {...rest} />
            </Layout>
          ) : (
            <Redirect to={ROOT} />
          )
        ) : (
          <Redirect
            to={{
              pathname: LOGIN,
              state: { redirectUrl: location.pathname },
            }}
          />
        
        );
      }}
    />
  );
};

export default PrivateRoute;
